import React from "react";

const UrlQrCode = ({ setQrData }) => (
    <div className="form-group general-field">
        <label htmlFor="qr-data">Conteúdo</label>
        <input type="text" id="qr-data" placeholder="https://qrcbr.com.br" onChange={(e) => setQrData(e.target.value)} />
    </div>
);

export default UrlQrCode;